module.exports = __webpack_public_path__ + "static/media/body-music.9e901eeb.jpg";